import {Route} from '@angular/router';
import {
  RegulatoryAnalysisComponent
} from '@app/features/analysis-refactor/pages/analysis-configuration/pages/regulatory-analysis/regulatory-analysis.component';

export const RegulatoryAnalysisRoutes : Route[]= [
  {
    path: '',
    component: RegulatoryAnalysisComponent,
    children: [
      {
        path: 'statutory-approvals',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/regulatory-analysis/pages/statutory-approvals/statutory-approvals.component')
      },
      {
        path: 'matrix',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/regulatory-analysis/pages/matrix/matrix.component')
      },
      {
        path: 'acquisition-litigation-bottlenecks',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/regulatory-analysis/pages/acquisition-litigation-bottlenecks/acquisition-litigation-bottlenecks.component')
      },
    ]
  }
]
